import { isFunction } from 'lodash';

/**
 * Simple FSA-compliant Action Logger
 */
export function loggingMiddleware() {
  return (next) => (action) => {
    if (
      process.env.NODE_ENV !== 'production' &&
      process.env.NODE_ENV !== 'test' &&
      !(process.versions && process.versions.node) &&
      !isFunction(action) &&
      !isFunction(action.payload)
    ) {
      // eslint-disable-next-line no-console
      console.log(action);
    }

    return next(action);
  };
}
